module.exports = new __parcel__URL__("macha.3ad5a73a.webp").toString();